import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TransactionsLayout from '../layouts/TransaksionLayout';

export const TransaksiKasirPages = () => {
  const navigate = useNavigate();
  const { user, isError } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) {
      navigate('/', { replace: true });
    }
  }, [isError, navigate]);

  return (
    <>
      <TransactionsLayout userUuid={user?.uuid} userRole={user?.role} />
    </>
  );
};
